import React, { useCallback } from 'react';
import RefreshIcon from 'mdi-react/RefreshIcon';
import { useDispatch, useSelector } from 'react-redux';

import { IconButton } from '@crm-framework/icon-button';
import { colors } from '@crm-framework/theme';

import {
  NotificationsHeaderWrapper,
  NotificationsHeaderContent,
  NotificationsHeader,
} from '../../styles';
import { NotificationBell } from '../notification-bell';
import { getNotificationData } from '../../selectors';
import { notificationsActions } from '../../NotificationsStore';

export const NotificationHeader = () => {
  const dispatch = useDispatch();
  const { isLoading, unreadMessages } = useSelector(getNotificationData);

  const onRefresh = useCallback(() => {
    dispatch(notificationsActions.refresh());
  }, []);

  return (
    <NotificationsHeaderWrapper>
      <NotificationsHeaderContent>
        <NotificationsHeader>Notifications</NotificationsHeader>
        <NotificationBell
          unreadMessages={unreadMessages}
          unreadMessageStyles={{ border: `2px solid ${colors.WHITE}` }}
        />
      </NotificationsHeaderContent>
      <IconButton
        withCircleHover
        appearance="default"
        icon={RefreshIcon}
        disabled={isLoading}
        onClick={onRefresh}
      />
    </NotificationsHeaderWrapper>
  );
};
